import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {PermissionService} from '../services/permission.service';
import {RedirectService} from '../services/redirect.service';

export const roleGuard: CanActivateFn = (route) => {

	const permission = inject(PermissionService);
	const redirect = inject(RedirectService);

	const roles = route.data?.['roles'];

	if (!permission.canAccess(roles)) {
		redirect.toDefaultRoute('Accesso negato');
		return false;
	}

	return true;
};
